import { CloseButton } from '@components/utility/buttons';
import {
    Button,
    ButtonProps,
    Dialog,
    DialogActions,
    DialogActionsProps,
    DialogProps,
    DialogTitle,
    DialogTitleProps,
    Typography,
} from '@mui/material';
import { clsx } from 'clsx';
import { ReactElement } from 'react';

interface Btn extends Omit<ButtonProps, 'children'> {
    title: string;
}

interface Props extends Omit<DialogProps, 'children'> {
    titleSX: ReactElement;
    secondaryBtnProps: Btn;
    primaryBtnProps: Btn;
    actionsProps?: DialogActionsProps;
    titleProps?: DialogTitleProps;
}

const GenericDialog = ({ titleSX, primaryBtnProps, secondaryBtnProps, actionsProps, titleProps, ...props }: Props) => {
    return (
        <Dialog
            {...props}
            disableEscapeKeyDown
            classes={{
                ...props.classes,
                paper: clsx(props.classes?.paper, 'dialog-paper rounded-2xl p-8 min-w-[850px]'),
            }}
        >
            <CloseButton onClick={() => props.onClose?.({}, 'backdropClick')} />
            <DialogTitle {...titleProps} className={clsx('flex gap-5 mt-12 justify-center', titleProps?.className)}>
                {titleSX}
            </DialogTitle>
            <DialogActions {...actionsProps} className={clsx('flex gap-5 mt-12', actionsProps?.className)}>
                <Button
                    fullWidth
                    color="secondary-alt"
                    className="rounded-full"
                    sx={{
                        border: '1px solid #00000029',
                    }}
                    {...secondaryBtnProps}
                >
                    <Typography fontSize={15} fontWeight={500} letterSpacing={0.46}>
                        {secondaryBtnProps.title}
                    </Typography>
                </Button>
                <Button
                    fullWidth
                    className="rounded-full"
                    sx={{
                        border: '1px solid #00000029',
                    }}
                    color="error"
                    {...primaryBtnProps}
                >
                    <Typography fontSize={15} fontWeight={500} letterSpacing={0.46}>
                        {primaryBtnProps.title}
                    </Typography>
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export { GenericDialog };
